"use client";

import { ArrowLeftCircle } from "@layer/icons";
import { CommandItem, CommandSeparator } from "@layer/ui/components";
import { findCommandParent } from "@layer/utils/lib/commands";
import { useAtomValue, useSetAtom } from "jotai";
import { useTranslations } from "next-intl";
import {
	commandPageAtom,
	commandParentAtom,
	selectCommandPageAtom,
} from "@/modules/command-bar/atoms/states/command-page-state";

const CommandBarBackButton = () => {
	const selectedCommandPage = useAtomValue(selectCommandPageAtom);
	const commandParent = useAtomValue(commandParentAtom);
	const commands = useAtomValue(commandPageAtom);
	const setSelectCommandPage = useSetAtom(selectCommandPageAtom);

	const t = useTranslations("Common.actions");

	const handleGoback = () => {
		if (!commandParent) {
			setSelectCommandPage(null);
			return;
		}

		const parentOfParent = findCommandParent(commands, commandParent.id);

		// If parent has no parent, it's a top-level group, so go back to root
		if (!parentOfParent) {
			setSelectCommandPage(null);
			return;
		}

		// Otherwise go back one level
		setSelectCommandPage(commandParent.id);
	};

	if (!selectedCommandPage || !commandParent) return null;

	return (
		<>
			<CommandItem
				onSelect={handleGoback}
				className="text-neutral-text gap-x-2"
			>
				<ArrowLeftCircle variant="filled" />
				{t("goBack")}
			</CommandItem>
			<CommandSeparator />
		</>
	);
};

export { CommandBarBackButton };
